import classNames from 'clsx';
import React from 'react';

import MinIcon from '@swf/core/assets/icons/minus-icon.svg';
import Add from '@swf/core/assets/icons/plus-icon.svg';

import styles from './LeaderboardCollapsible.scss';

interface OwnProps {
  start: number;
  end: number;
  index: number;
  isExpanded: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?(e: MouseEvent | any): any;
  legacyWidget?: boolean;
}

const LeaderboardCollapsible: React.FC<OwnProps> = ({
  start,
  end,
  index,
  isExpanded,
  onClick,
  legacyWidget
}) => (
  <tr
    key={index}
    className={classNames(styles.row, { [styles.expanded]: isExpanded })}
    onClick={onClick}
  >
    <td className={classNames(styles.range)}>
      <span>
        #{start} - #{end}
      </span>
    </td>
    <td />

    <td className={classNames(styles.expandMark, legacyWidget && styles.legacy)}>
      <span>{isExpanded ? <MinIcon /> : <Add />}</span>
    </td>
  </tr>
);

export default LeaderboardCollapsible;
